var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-container",
    { staticClass: "logged-view", attrs: { fluid: "" } },
    [
      _c("Header"),
      _c(
        "sui-grid",
        { staticClass: "centered" },
        [
          _c("sui-grid-row", { attrs: { centered: "" } }, [
            _c("div", { staticClass: "text" }, [
              _vm._v("You have successfully logged out."),
            ]),
          ]),
          _c(
            "sui-grid-row",
            { attrs: { centered: "" } },
            [
              _c(
                "router-link",
                { attrs: { to: "/account/login" } },
                [
                  _c(
                    "sui-button",
                    {
                      staticStyle: { "background-color": "#2a998b" },
                      attrs: { color: "teal" },
                    },
                    [_vm._v(" Log back in ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }